export const avatar = {
  baseStyle: {
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: "base"
  },
  sizes: {},
  variants: {},
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}
